import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import LogoHero from './components/LogoHero';
import AboutSection from './components/AboutSection';
import TreatmentsOverview from './components/TreatmentsOverview';
import MesoporationSection from './components/MesoporationSection';
import PhilosophySection from './components/PhilosophySection';
import ServicesSection from './components/ServicesSection';
import StudioSection from './components/StudioSection';
import ContactSection from './components/ContactSection';
import { SectionShell, resolveSectionOrder, useDesign } from '@/content/design';

/* The movable content sections, keyed for ordering & hiding. */
const SECTION_REGISTRY: Record<string, { label: string; Comp: () => JSX.Element }> = {
  about: { label: 'Über mich', Comp: AboutSection },
  behandlungen: { label: 'Behandlungen', Comp: TreatmentsOverview },
  mesoporation: { label: 'Mesoporation', Comp: MesoporationSection },
  philosophy: { label: 'Meine Philosophie', Comp: PhilosophySection },
  leistungen: { label: 'Leistungen & Preise', Comp: ServicesSection },
  studio: { label: 'Studio', Comp: StudioSection },
  kontakt: { label: 'Kontakt', Comp: ContactSection },
};

export default function Home() {
  useScrollAnimation();
  const { design } = useDesign();
  const order = resolveSectionOrder(design);

  return (
    <>
      <header>
        <Navbar />
      </header>
      <main className="min-h-screen bg-warm-light">
        <LogoHero />
        {order.map((key) => {
          const entry = SECTION_REGISTRY[key];
          if (!entry) return null;
          const { label, Comp } = entry;
          return (
            <SectionShell key={key} sectionKey={key} label={label}>
              <Comp />
            </SectionShell>
          );
        })}
      </main>
      <Footer />
    </>
  );
}
